import React, { useState, useRef, useEffect } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { format } from 'date-fns';
import './TimeRangeSlider.css';

const TimeRangeSlider = ({ range, value, onChange, timeUnit, shouldUpdate = true }) => {
  // Early return if update is not needed
  if (!shouldUpdate) {
    return null;
  }

  // Track dragging state for potential optimizations
  const [isDragging, setIsDragging] = useState(false);
  const lastUpdateRef = useRef(0);
  const updateThrottleMs = 50; // Throttle updates during drag
  
  const [minTime, maxTime] = range;

  const formatDate = (timestamp) => {
    return format(new Date(timestamp), 'dd MMM yyyy');
  };

  // Called during drag operations
  const handleChange = (values) => {
    const now = Date.now();
    
    // Always update immediately if not dragging
    // During drag, throttle updates to reduce render frequency
    if (!isDragging || now - lastUpdateRef.current > updateThrottleMs) {
      onChange(values);
      lastUpdateRef.current = now;
    }
  };
  
  // Called when the drag starts
  const handleBeforeChange = () => {
    setIsDragging(true);
  };
  
  // Called when the drag ends
  const handleAfterChange = (values) => {
    setIsDragging(false);
    // Ensure we always get a final update
    onChange(values);
  };

  return (
    <div className="time-range-slider">
      <Slider
        range
        min={minTime}
        max={maxTime}
        value={value}
        onChange={handleChange}
        onBeforeChange={handleBeforeChange}
        onAfterChange={handleAfterChange}
        railStyle={{ backgroundColor: 'var(--color-action-disabled-background)', height: 2 }}
        trackStyle={[{ backgroundColor: 'var(--color-primary)', height: 2 }]}
        handleStyle={[
          {
            backgroundColor: 'var(--color-background-paper)',
            border: '2.5px solid var(--color-primary)',
            height: 16,
            width: 16,
            marginTop: -7,
            boxShadow: '0 2px 4px var(--color-action-disabled-background)',
          },
          {
            backgroundColor: 'var(--color-background-paper)',
            border: '2.5px solid var(--color-primary)',
            height: 16,
            width: 16,
            marginTop: -7,
            boxShadow: '0 2px 4px var(--color-action-disabled-background)',
          },
        ]}
      />
      <div className="time-range-labels">
        <span>{formatDate(value[0])}</span>-
        <span>{formatDate(value[1])}</span>
      </div>
    </div>
  );
};

export default React.memo(TimeRangeSlider);